//require('dotenv').config();

let url = process.env.REACT_APP_BASE_URL

export default url